import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  const linkClasses = 'underline hover:text-white transition-colors';

  return (
    <footer className="bg-primary px-6 py-8">
      <div className="w-full flex flex-col items-center gap-2 max-w-7xl mx-auto">
        <p className="text-secondary text-sm">
          {t('contact.footer.copyright', { year: currentYear })}
        </p>

        <p className="text-slate-400 text-xs">
          <Trans
            i18nKey="contact.footer.attribution"
            components={[
              <span />,
              <a
                href="https://sketchfab.com/3d-models/cyberpunk-laptop-552a46e9047c4e5e8104de224955358c"
                target="_blank"
                rel="noopener noreferrer"
                className={linkClasses}
              />,
              <span />,
              <a
                href="https://sketchfab.com/blue-odym"
                target="_blank"
                rel="noopener noreferrer"
                className={linkClasses}
              />,
              <span />,
              <a
                href="http://creativecommons.org/licenses/by/4.0/"
                target="_blank"
                rel="noopener noreferrer"
                className={linkClasses}
              />,
            ]}
          />
        </p>
      </div>
    </footer>
  );
};

export default Footer;
